import { gql, useQuery } from "@apollo/client";
import {
  createContext,
  FC,
  Reducer,
  useCallback,
  useContext,
  useReducer,
} from "react";
import { Customer } from "../api/schema";

export const customer_query = gql`
  query customer_query {
    customers {
      id
      name
      company
      phone
      email
    }
  }
`;

interface CustomerQueryReponse {
  customers: Customer[];
}

interface CustomerStore {
  customers: Customer[];
  loading: boolean;
  error?: any;
}

export const CustomerRepositoryContext = createContext<CustomerStore>({
  customers: [],
  loading: true,
});

export const RefetchRepositoryContext = createContext<() => void>(() => {});

export const CustomerRepositoryProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer<Reducer<CustomerStore, CustomerStore>>(
    (__: CustomerStore, new_value: CustomerStore) => new_value,
    { loading: true, customers: [] }
  );

  const { refetch } = useQuery<CustomerQueryReponse>(customer_query, {
    fetchPolicy: "no-cache",
    onCompleted: (data) =>
      dispatch({ loading: false, customers: data.customers }),
    onError: (error) => dispatch({ loading: false, error, customers: [] }),
  });

  const fetch_new_data = useCallback(() => {
    console.log("refetching...");
    refetch().then((v) => {
      if (v.error) {
        console.error(v.error);
      } else if (v.loading) {
        console.log("loading...");
      } else if (v.data) {
        console.log("setting new data");
        dispatch({ loading: false, customers: v.data.customers });
      }
    });
  }, [dispatch, refetch]);

  return (
    <CustomerRepositoryContext.Provider value={state}>
      <RefetchRepositoryContext.Provider value={fetch_new_data}>
        {children}
      </RefetchRepositoryContext.Provider>
    </CustomerRepositoryContext.Provider>
  );
};

export const useCustomers = (): [CustomerStore, () => void] => [
  useContext(CustomerRepositoryContext),
  useContext(RefetchRepositoryContext),
];
